import { AIDiagram } from "./AIDiagram";
import type { Theme } from "./theme";

const AI_USES = [
  "structure information",
  "accelerate analysis",
  "improve consistency",
  "support collaboration across stakeholders",
];

export function AISection({ theme }: { theme: Theme }) {
  return (
    <section id="ai" style={{ padding: "120px 0", borderTop: `1px solid ${theme.border}` }}>
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: "0 40px",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 80,
          alignItems: "center",
        }}
      >
        <div>
          <div
            style={{
              fontSize: 12,
              fontWeight: 500,
              letterSpacing: 0.6,
              textTransform: "uppercase",
              color: theme.accentFg,
              marginBottom: 14,
            }}
          >
            AI positioning
          </div>
          <h2
            style={{
              fontSize: "clamp(32px, 3.6vw, 48px)",
              lineHeight: 1.05,
              letterSpacing: "-1.2px",
              fontWeight: 600,
              color: theme.fg,
              margin: "0 0 20px",
              textWrap: "balance",
            }}
          >
            AI where it helps. Human judgement where it matters.
          </h2>
          <p
            style={{
              fontSize: 17,
              color: theme.fgMute,
              lineHeight: 1.6,
              margin: "0 0 24px",
            }}
          >
            Rarion supports decision-making — it does not replace it. It does not automate hiring
            decisions.
          </p>
          <p
            style={{
              fontSize: 15,
              color: theme.fgMute,
              lineHeight: 1.6,
              margin: "0 0 20px",
            }}
          >
            AI is used to:
          </p>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {AI_USES.map((t, i) => (
              <li
                key={t}
                style={{
                  display: "flex",
                  gap: 14,
                  padding: "10px 0",
                  fontSize: 15,
                  color: theme.fg,
                  borderTop: `1px solid ${theme.border}`,
                }}
              >
                <span
                  style={{
                    fontFamily: theme.mono,
                    fontSize: 11,
                    color: theme.fgMute,
                    minWidth: 20,
                  }}
                >
                  0{i + 1}
                </span>
                {t}
              </li>
            ))}
          </ul>
          <p
            style={{
              fontSize: 15,
              color: theme.fgMute,
              lineHeight: 1.6,
              marginTop: 24,
              fontStyle: "italic",
            }}
          >
            Decisions remain human-led and collaborative.
          </p>
        </div>
        <AIDiagram theme={theme} />
      </div>
    </section>
  );
}
